import * as React from "react";

export const EmptySquareCode = () => <div className="fallback square" />;

export const EmptyBarcode = () => <div className="fallback bar" />;
